/* Tabla de tallas nativa (sin apps) - Merina */
(function () {
  'use strict';

  if (window.merinaSizeChartReady) return;
  window.merinaSizeChartReady = true;

  var LOCK_CLASS = 'size-chart-lock';
  var SIZE_NAMES = ['talla', 'tallas', 'size'];
  var TRIGGER_TEXT_RE = /tabla de tallas/gi;
  var TRIGGER_TEXT_TEST_RE = /tabla de tallas/i;

  function openChart(dialog) {
    if (!dialog) return;
    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    document.documentElement.classList.add(LOCK_CLASS);
  }

  function closeChart(dialog) {
    if (!dialog) return;
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
    document.documentElement.classList.remove(LOCK_CLASS);
  }

  /* Delegacion de eventos: sigue funcionando aunque el selector de variantes se vuelva a pintar */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var opener = target.closest('[data-size-chart-open]');
    if (opener) {
      event.preventDefault();
      openChart(document.getElementById(opener.getAttribute('data-size-chart-open')));
      return;
    }

    var closer = target.closest('[data-size-chart-close]');
    if (closer) {
      closeChart(closer.closest('dialog'));
      return;
    }

    /* Clic en el fondo oscuro */
    if (target.tagName === 'DIALOG' && target.classList.contains('size-chart')) {
      closeChart(target);
    }
  });

  /* Cierre con la tecla Esc u otros cierres nativos */
  document.addEventListener(
    'close',
    function (event) {
      var el = event.target;
      if (el && el.classList && el.classList.contains('size-chart')) {
        document.documentElement.classList.remove(LOCK_CLASS);
      }
    },
    true
  );

  /* ------------------------------------------------------------------
     Compatibilidad con el selector visual de variantes (apps tipo
     Swatch King / Variant Hero): esas apps ocultan el <fieldset>
     original del tema (le ponen la clase "sk-hidden") y pintan su
     propio HTML (".sk-group" > ".sk-group-label" + ".sk-swatches").
     Como leen el texto tal cual de nuestro <legend> original, el texto
     del boton "Tabla de tallas" se cuela como texto suelto (no
     clicable) dentro de su etiqueta. Aqui limpiamos ese texto y
     clonamos ahi el boton real, repitiendolo cada vez que la app
     vuelve a pintar.
     ------------------------------------------------------------------ */
  function cleanLabelText(label) {
    for (var i = 0; i < label.childNodes.length; i++) {
      var node = label.childNodes[i];
      if (node.nodeType === 3 && TRIGGER_TEXT_TEST_RE.test(node.textContent)) {
        node.textContent = node.textContent
          .replace(TRIGGER_TEXT_RE, '')
          .replace(/\s+/g, ' ')
          .replace(/\s+:/, ':')
          .trim();
        if (node.textContent && !/:$/.test(node.textContent) && label.querySelector('.sk-selected-value')) {
          node.textContent += ':';
        }
        node.textContent += ' ';
      }
    }
  }

  function isSizeGroupLabel(swatches) {
    var raw = (swatches && swatches.getAttribute('aria-label')) || '';
    var firstWord = raw.replace(/\s+/g, ' ').trim().toLowerCase().split(' ')[0];
    return SIZE_NAMES.indexOf(firstWord) !== -1;
  }

  function injectIntoAppSwatchGroups() {
    var groups = document.querySelectorAll('.sk-group');
    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];
      var swatches = group.querySelector('.sk-swatches');
      if (!isSizeGroupLabel(swatches)) continue;

      var label = group.querySelector('.sk-group-label');
      if (!label) continue;

      cleanLabelText(label);

      if (label.querySelector('.size-chart__trigger')) continue;

      var source = document.querySelector('variant-selects .size-chart__trigger');
      if (!source) continue;

      label.appendChild(source.cloneNode(true));
    }
  }

  /* Variante antigua (por si alguna app usa este marcado): un elemento
     <variant-swatch-king> con un hueco ".swatch-size-chart" por opcion. */
  function injectIntoSwatchKing() {
    var groups = document.querySelectorAll('variant-swatch-king [option-name]');
    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];
      var name = (group.getAttribute('option-name') || '').trim().toLowerCase();
      if (SIZE_NAMES.indexOf(name) === -1) continue;

      var slot = group.querySelector('.swatch-size-chart');
      if (!slot || slot.querySelector('.size-chart__trigger')) continue;

      var scope = group.closest('section, product-info') || document;
      var source = scope.querySelector('variant-selects .size-chart__trigger') || document.querySelector('variant-selects .size-chart__trigger');
      if (!source) continue;

      slot.appendChild(source.cloneNode(true));
    }
  }

  function injectAll() {
    injectIntoAppSwatchGroups();
    injectIntoSwatchKing();
  }

  var scheduled = false;
  function scheduleInject() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      injectAll();
    });
  }

  function start() {
    injectAll();
    if ('MutationObserver' in window && document.body) {
      new MutationObserver(scheduleInject).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
